export const navLinks = [
  { label: '首页', path: '/' },
  { label: '分类浏览', path: '/category' },
  { label: '关于我们', path: '/about' },
];

export const footerLinks = {
  platform: {
    title: '平台',
    links: [
      { label: '首页', path: '/' },
      { label: '分类浏览', path: '/category' },
      { label: '关于我们', path: '/about' },
    ],
  },
  categories: {
    title: '热门分类',
    links: [
      { label: '影视娱乐', path: '/category?tab=entertainment' },
      { label: '生活方式', path: '/category?tab=lifestyle' },
      { label: '科技数码', path: '/category?tab=tech' },
      { label: '文化艺术', path: '/category?tab=culture' },
      { label: '知识教育', path: '/category?tab=education' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '帮助中心', path: '/about#faq' },
      { label: '联系我们', path: '/about#contact' },
      { label: '内容政策', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  },
};

export const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', url: '#' },
  { icon: 'ri-wechat-line', label: '微信', url: '#' },
  { icon: 'ri-bilibili-line', label: 'B站', url: '#' },
  { icon: 'ri-video-line', label: '抖音', url: '#' },
];